import { Component, OnInit } from '@angular/core';
import { Attending } from '../../model/attending';
import { ActivatedRoute } from '@angular/router';
import { AttendingService } from '../../service/attending.service';

@Component({
  selector: 'tx-show-attending',
  templateUrl: './show-attending.component.html',
  styleUrls: ['./show-attending.component.css']
})
export class ShowAttendingComponent implements OnInit {
  attending: Attending;

  constructor(private _route: ActivatedRoute,
              private _attendingService: AttendingService) {
    this.setUpObservers();
    this.findAttending();
  }

  ngOnInit() {
  }

  findAttending() {
    this._route.params.subscribe(params => {
      if (params['id']) {
        const attendingId = +params['id'];
        this.showCurrent(attendingId);
      }
    });
  }

  private showCurrent(id) {
    this._attendingService.showCurrent(id);
  }

  private setUpObservers() {
    this._attendingService.current$
      .subscribe(attending => {
        this.attending = attending;
      });
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/component/show-attending/show-attending.component.ts